import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { concat } from 'lodash';

import Noat from '../../../pages/hhoat/3_1_0_root';
import Hist from '../../../pages/hhoat/3_1_1_main';
import Borluulalt from '../../../pages/hhoat/3_2_1_niigmiin_daatgal';
import Tailan from '../../../pages/hhoat/3_4_1_tailan';
import hm11_1 from '../../../pages/hhoat/3_3_1_hm11_1';
import hm11_2 from '../../../pages/hhoat/3_3_2_hm11_2';
import hm11_3 from '../../../pages/hhoat/3_3_3_hm11_3';
import S4_2_HereglegchMedeelel from '../../../pages/userProfile/newUserProfile';
import S1_3_UserAdd from '../../../pages/s1_3_Hereglegch';
import S4_1_TatvarTulugchMedeelel from '../../../pages/s4_1_TatvarTulugch';
import E_tax from '../../../pages/e_tax';

export const routeList = {
  Noat: {
    path: '/hhoat',
    component: Noat,
    permission: false,
  },
  History: {
    path: '/hhoat/history',
    component: Hist,
    permission: false,
  },
  NiigmiinDaatgal: {
    path: '/hhoat/borluulalt',
    component: Borluulalt,
    permission: false,
  },
  hm11_1: {
    path: '/hhoat/hm11_1',
    component: hm11_1,
    permission: false,
  },
  hm11_2: {
    path: '/hhoat/hm11_2',
    component: hm11_2,
    permission: false,
  },
  hm11_3: {
    path: '/hhoat/hm11_3',
    component: hm11_3,
    permission: false,
  },
  Tailan: {
    path: '/hhoat/tailan',
    component: Tailan,
    permission: false,
  },
  HereglegchMedeelel: {
    path: '/hhoat/hereglegchMedeelel',
    component: S4_2_HereglegchMedeelel,
    permission: false,
  },
  UserAdd: {
    path: '/hhoat/tohirgoo/userAdd',
    component: S1_3_UserAdd,
    permission: false,
  },
  TatvarTulugchMedeelel: {
    path: '/hhoat/tatvarTulugch/medeelel',
    component: S4_1_TatvarTulugchMedeelel,
    permission: false,
  },
  E_tax: {
    path: '/hhoat/e_tax',
    component: E_tax,
    permission: false,
  },
};

const Entity = () => {
  let childList = [];
  Object.values(routeList).forEach((i) => {
    const { children = [] } = i;
    if (children.length > 0) {
      childList = concat(childList, children);
    }
  });
  const mainList = [...Object.values(routeList), ...childList];
  return (
    <Switch>
      {mainList.map(({ path, component }, key) => (
        // eslint-disable-next-line react/no-array-index-key
        <Route exact path={path} component={component} key={key} />
      ))}
    </Switch>
  );
};

export default Entity;
